import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_HOSPITALS_KEY, GET_HOSPITAL_BY_ID_KEY } from '_api/queries/hospital';
import { Hospital, HospitalPayload } from '_api/types';

export const CREATE_HOSPITAL_KEY = 'create-hospital';

export const useCreateHospital = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Hospital, HospitalPayload>(
    () => '/hospital/create',
    'post',
    {},
    {
      mutationKey: [CREATE_HOSPITAL_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_HOSPITALS_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_HOSPITAL_BY_ID_KEY] });
      },
    },
    (body: HospitalPayload) => JSON.stringify(body),
  );
};
